if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.storeAvailabilityButton = this.querySelector('[data-store-availability-button]');
      if (this.storeAvailabilityButton) this.storeAvailabilityButton.addEventListener('click', (e) => this.openStoreAvailability(e));
      if (this.form.dataset.compareAtPrice) this.compareAtPrice = parseInt(this.form.dataset.compareAtPrice);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      document.dispatchEvent(new Event('product-form:add-start'));

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // GA ecommerce events
          window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: window.Shopify.currency.active || 'EUR',
              value: response.final_price / 100,
              items: [{
                item_name: response.product_title, // Name or ID is required.
                item_id: response.product_id.toString(),
                price: this.compareAtPrice ? this.compareAtPrice / 100 : response.final_price / 100,
                item_variant: response.id.toString(),
                quantity: response.quantity
              }]
            }
          });

          // giosg customer data
          fetch(window.routes.cart_url + '.js', {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (content) {
            content.text().then(function (cartString) {
              const cartObject = JSON.parse(cartString);
              const sanitizedItems = cartObject.items.map(item => {
                return {name: item.product_title, quantity: item.quantity, price: item.final_price / 100 }
              })
              _giosg(function () {
                giosg.api.shoppingCart.submit(sanitizedItems).then(function() {
                  // Shopping cart data is now submitted
                  // You can run code here after the promise resolves if you want to, but it's not mandatory
                })
              })
            })
          })
          
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.dispatchEvent(new Event('product-form:add-end'));
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    openStoreAvailability(event) {
      const storeAvailabilityElement = document.querySelector('.product-stores')
      if (storeAvailabilityElement) {
        if (storeAvailabilityElement.closest('quick-add-modal')) {
          window.location = event.target.closest('form').dataset.variantLink;
          return;
        }
        const storeAvailabilityAccordion = storeAvailabilityElement.closest('details');
        storeAvailabilityAccordion.setAttribute('open', '');
        storeAvailabilityAccordion.scrollIntoView(true);
      }
    }
  });
}
